import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'
/** UTIILS */

export default class TemplateApi extends BaseAPI {
    static findAll(props: FindAllInterface): Promise<any> {
        return this.api.get('treatment-templates', { params: { ...props } }).then((res) => res)
    }

    static updateStatus(id: number, status: string): Promise<any> {
        return this.api.patch(`treatment-templates/${id}/status`, { id, status })
    }

    static remove(id: number) {
        return this.api.delete(`treatment-templates/${id}`)
    }

    static create(playload: any) {
        return this.api.post('treatment-templates', playload)
    }

    static findById(id: number): Promise<any> {
        return this.api.get(`treatment-templates/${id}`)
    }

    static update(id: number, body: any) {
        return this.api.patch(`treatment-templates/${id}`, body)
    }
}